import React, { useState } from 'react';
import { useAddTableMutation } from '@/redux';
import { useAppFindFormik } from '@/components';
import { AddTableDto, ProjectDto } from '@/core';
import { FormValueType, TableTypesEnum } from './hooks';
import { TableForm } from './TableForm';

const getInitialValue = (): FormValueType => ({
  type: TableTypesEnum.Main,
  name: '',
  columns: undefined,
});

type PropsType = {
  projectData: ProjectDto;
};

export const ProjectsAddTableForm = ({ projectData }: PropsType) => {
  const form = useAppFindFormik('add-table');
  const [addEpicGroup] = useAddTableMutation();
  const initialValue = getInitialValue();
  const [pickedColumns, setPickedColumns] = useState<string[] | undefined>(initialValue.columns);
  const [pickedTableType, setPickedTableType] = useState(initialValue.type);

  const clearForm = () => {
    setPickedColumns(initialValue.columns);
    setPickedTableType(initialValue.type);
    form.current?.resetForm();
  };

  const handleSubmit = (tableData: AddTableDto) => {
    addEpicGroup({
      tableData: {
        ...tableData,
        columns: pickedColumns?.map((columnId, index) => ({ columnId, sequence: index }))!,
      },
      projectId: projectData.id,
    })
      .unwrap()
      .then(() => clearForm());
  };

  return (
    <TableForm
      handleSubmit={handleSubmit}
      projectData={projectData}
      formUid="add-table"
      initialValue={initialValue}
      pickedColumns={pickedColumns}
      pickedTableType={pickedTableType}
      setPickedColumns={(columns) => setPickedColumns(columns)}
      clearForm={clearForm}
      setPickedTableType={(type) => setPickedTableType(type)}
    />
  );
};
